export default "__VITE_ASSET__DjtBwLgv__"